import { Table } from '../shared/ui/table';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import React from 'react';
import { OrderTableData } from '../types/orders/Order';
import { OrderEnums } from '../shared/constants/OrderEnums';
import { AlarmEnum } from '../shared/constants/AlarmEnum';

const orderEnums = new OrderEnums();

export const getDeliveryLabel = (order: OrderTableData, onOpenActivity: any) => {
    if (orderEnums.status.isConcluded(order.status.id.toString())) {
        return (
            <div style={{ display: 'flex', justifyContent: 'start' }}>
                {AlarmEnum.color.isWhite(order.alarm) && order.cec_length !== 0 && 'Comprovante: '}
                {AlarmEnum.color.isWhite(order.alarm) && order.cec_length !== 0 && (
                    <HiOutlineDocumentReport
                        key={order.id}
                        style={{ fontSize: '18px', cursor: 'pointer' }}
                        onClick={() => onOpenActivity(order, order.sap_numbers)}
                    />
                )}
            </div>
        );
    } else if (orderEnums.status.isUnsuccessful(order.status.id.toString())) {
        return <></>;
    } else {
        let turns_message = '';
        const turnos = [];
        const deliveryTurn = order.delivery_window.split('/');

        if (deliveryTurn.includes('manha')) turnos.push('manhã');
        if (deliveryTurn.includes('tarde')) turnos.push('tarde');
        if (deliveryTurn.includes('noite')) turnos.push('noite');

        if (turnos.length === 3) {
            turns_message = ' ';
        } else if (turnos.length > 0) {
            turns_message += ' no período da ' + turnos.join(' ou ');
        }

        if (order.type === 'Implantação') return `Estimativa de entrega: ${order.delivery_forecast}${turns_message}`;
        if (order.type === 'Recolhimento')
            return `Estimativa de recolhimento em: ${order.delivery_forecast}${turns_message}`;
        if (order.type === 'Recarga') return `Estimativa de recarga em: ${order.delivery_forecast}${turns_message}`;
        if (order.type === 'Assistência Técnica') return `Agendamento para: ${order.delivery_forecast}${turns_message}`;
        if (order.type === 'Descartáveis') return `${order.delivery_forecast}${turns_message}`;
        if (order.type === 'Serviço' || order.type === 'Sublocação') return `${order.delivery_forecast}${turns_message}`;

        return '';
    }
};

export const parseObs = (obs: any, mapProd: any) => {
    try {
        const obj = JSON.parse(obs);
        return (
            <div>
                <p style={{ padding: '0px', margin: '2px' }}>
                    {Object.keys(obj.terms).length > 0 || Object.keys(obj.Search).length > 0 ? (
                        <React.Fragment>
                            <b>Detalhes da ocorrência:</b> {obj.obs}
                        </React.Fragment>
                    ) : (
                        obj.obs
                    )}
                </p>
                {Object.keys(obj.terms).length > 0 ? (
                    <p>
                        <b>Termos buscados:</b>{' '}
                        {Object.keys(obj.terms).map((x, i) => (
                            <i key={i}>{obj.terms[x].join(', ')}</i>
                        ))}
                    </p>
                ) : (
                    <></>
                )}
                {Object.keys(obj.Search).length > 0 ? (
                    Object.keys(obj.Search).map((eqId, i) => (
                        <Table
                            key={i}
                            header={['Problema', 'Causa', 'Solução']}
                            data={(obj.Search[eqId] ?? [])
                                .map((x: any) => {
                                    const c = { ...x };
                                    delete c.genId;
                                    return c;
                                })
                                .flat()}
                        />
                    ))
                ) : (
                    <></>
                )}
            </div>
        );
    } catch (e) {
        return obs;
    }
};

export const genericOrderCode = '85000378';
export const isGenericOrder = (code: string) => code === genericOrderCode;

export const genericCylinderCode = '80000017';
export const isGenericCylinder = (cylinder: any) =>
    cylinder?.id === genericCylinderCode || cylinder?.code === genericCylinderCode;
